import { OnMessageCallback } from 'mqtt';
import { commandActions } from './commandSlice';
import { store } from '../../app/store';

export const commandMqttParser: OnMessageCallback = (topic: any, payload: any, packet: any): void => {
    const msgCommand = JSON.parse(payload.toString());

    store.dispatch(commandActions.add_or_edit_command_success({
        id: msgCommand.id,
        type: msgCommand.payload.type,
        source: msgCommand.source,
        status: msgCommand.status,
        parameters: msgCommand.payload,
        created: msgCommand.created,
        updated: msgCommand.last_update
    }));
};